import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';
import {
  Button,
  HStack,
  Modal,
  theme,
  useResponsive,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import type { FooterProps } from '../CreditCardForm.types';

export const LineItem = ({
  style,
  children,
}: Pick<ViewProps, 'style' | 'children'>) => {
  const { currentBreakpoint } = useResponsive();
  const paddingHorizontal = currentBreakpoint.isXS ? 16 : 24;
  const dynamic = useStyle(() => ({ paddingHorizontal }), [paddingHorizontal]);

  return <View style={[styles.lineItem, dynamic, style]}>{children}</View>;
};

export const Footer = (props: FooterProps) => {
  const { mode, isSaving, isDeleting, canSubmit, onDelete, onSubmit } = props;

  const { t } = useLocalizationContext();
  const isEditing = mode === 'edit';

  return (
    <Modal.Footer style={styles.footer} withoutTopBorder>
      <HStack
        itemsPerRow={isEditing ? 2 : 1}
        customSpacing={theme.spacing['4']}
      >
        {isEditing ? (
          <Button
            testID="credit-card-form.remove"
            size="large"
            palette="caution"
            isLoading={isDeleting}
            accessibilityRole="button"
            accessibilityLabel={t('credit-card-form.remove')}
            accessibilityHint={t('credit-card-form.remove')}
            onPress={onDelete}
          >
            {t('credit-card-form.remove')}
          </Button>
        ) : null}

        <Button
          testID="credit-card-form.submit"
          size="large"
          palette="primary"
          isLoading={isSaving}
          disabled={!canSubmit}
          accessibilityRole="button"
          accessibilityLabel={t('credit-card-form.save')}
          accessibilityHint={t('credit-card-form.save')}
          accessibilityState={{ disabled: !canSubmit }}
          onPress={onSubmit}
        >
          {t('credit-card-form.save')}
        </Button>
      </HStack>
    </Modal.Footer>
  );
};

const styles = StyleSheet.create({
  lineItem: {
    marginBottom: theme.spacing['6'],
  },
  footer: {
    flexDirection: 'row',
    padding: theme.spacing['6'],
    paddingTop: theme.spacing['6'],
  },
});
